// modal/detail/ui/LogItem.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { PillIcon } from 'shared/ui/soft/PillIcon';

export function LogItem({ tone = 'blue', icon, title, meta, right }) {
  const theme = useMuiTheme();

  return (
    <MDBox
      sx={{
        p: 1.15,
        borderRadius: '16px',
        border: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        gap: 1.2,
      }}
    >
      <PillIcon icon={icon} tone={tone} />
      <MDBox sx={{ minWidth: 0 }}>
        <MDTypography variant="button" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
          {title}
        </MDTypography>
        <MDTypography variant="caption" sx={{ color: theme.palette.text.secondary }}>
          {meta}
        </MDTypography>
      </MDBox>
      {right ? <MDBox sx={{ ml: 'auto' }}>{right}</MDBox> : null}
    </MDBox>
  );
}
